/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { useForm } from 'react-hook-form';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const MyDiskCreateFolderModal = forwardRef(({ ...props }, ref) => {
  const { createFolderDisc, createNewFolder, createFolderLoading } =
    useContext(DiskContext);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const name = watch('name');
  const onSubmit = ({ name }) => {
    createNewFolder(name);
  };
  const { t } = useTranslator();
  const direction = useDirection();
  return (
    <>
      <Modal  size= {isMobile ? "sm": "2xl"} {...createFolderDisc}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
            <ModalHeader>{t('myDisk.createNewFolder') || "Create new folder"}</ModalHeader>
            <ModalBody>
              <FormControl isInvalid={errors?.name}>
                <FormLabel px={2}>{t('myDisk.name') || "Name"}</FormLabel>
                <Input borderRadius="full" placeholder={t('myDisk.folderName') || "Folder name"} {...register('name', { required: true })} />
                <FormErrorMessage>{t('myDisk.pleaseEnterValidName') || "Please enter a valid name"}</FormErrorMessage>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button
                isDisabled={createFolderLoading || (!name || name.trim().length === 0)}
                borderRadius="30px"
                isLoading={createFolderLoading}
                type="submit"
                variant="primary"
              >
                {t('myDisk.create') || "Create"}
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
});
